"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = ordinalSuffix;
function ordinalSuffix(num) {
  var float = parseFloat(num);
  var digits = [float % 10, float % 100];
  var ordinals = ['st', 'nd', 'rd', 'th'];
  var oPattern = [1, 2, 3, 4];
  var tPattern = [11, 12, 13, 14, 15, 16, 17, 18, 19];
  return oPattern.includes(digits[0]) && !tPattern.includes(digits[1]) ? ordinals[digits[0] - 1] : ordinals[3];
}